import React, { useState, useEffect } from "react";
import { useAuth } from "../Main/Components/Context/authContext";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField // Importar TextField de Material-UI
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  addDoc,
  collection,
  getDocs,
  deleteDoc,
  doc
} from "firebase/firestore";
import { db2 } from "../Main/Components/firebase";
import "./Documentation.style.css";

const Documentation = () => {
  const { user } = useAuth();
  const [documents, setDocuments] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [documentName, setDocumentName] = useState(""); // Nuevo estado para el nombre del documento

  // Función para obtener los documentos de la colección 'documents'
  const getDocuments = async () => {
    const querySnapshot = await getDocs(collection(db2, "documents"));
    const documentsData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));
    setDocuments(documentsData);
  };

  // Función para subir un documento en base64 a Firebase
  const uploadDocument = async () => {
    try {
      const file = selectedFile;
      const reader = new FileReader();

      reader.onloadend = async () => {
        // Convertir el archivo a base64
        const base64String = reader.result.split(",")[1]; // Obtenemos la parte base64 del resultado
        // Subir el archivo a Firebase con el nombre
        await addDoc(collection(db2, "documents"), {
          file: base64String,
          name: file.name,
          name2: documentName
        });
        getDocuments(); // Actualizar los datos después de subir un documento
        setDocumentName(""); // Limpiar el nombre del documento después de subirlo
      };

      reader.readAsDataURL(file); // Lee el archivo como base64
    } catch (error) {
      console.error("Error uploading document: ", error);
    }
  };

  // Función para borrar un documento
  const deleteDocument = async (id) => {
    try {
      await deleteDoc(doc(db2, "documents", id));
      getDocuments(); // Actualizar los datos después de eliminar un documento
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };

  // Obtener los documentos al cargar el componente
  useEffect(() => {
    getDocuments();
  }, []);

  // Función para mostrar el documento en base64
  const viewDocument = (file, name) => {
    console.log(file, "file");
    console.log(name, "name");
    setSelectedDocument({ file, name });
  };

  // Función para renderizar el documento en base al tipo
  const renderDocument = () => {
    if (selectedDocument) {
      const { file, name } = selectedDocument;
      const extension = name.split(".").pop();
      console.log(extension, "extension");
      switch (extension) {
        case "pdf":
          return (
            <embed
              src={`data:application/pdf;base64,${file}`}
              type="application/pdf"
              width="100%"
              height="800px"
              style={{ border: "1px solid #333333", width: "100%" }}
            />
          );
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
          return (
            <img
              src={`data:image/${extension};base64,${file}`}
              alt={name}
              style={{ maxWidth: "80%" }}
            />
          );
        case "mp4":
        case "webm":
        case "ogg":
          return (
            <video controls width="100%">
              <source
                src={`data:video/${extension};base64,${file}`}
                type={`video/${extension}`}
              />
              Your browser does not support the video tag.
            </video>
          );
        default:
          return null;
      }
    }
    return null;
  };

  return (
    <div>
      <h1>Documentos</h1>
      {/* Formulario para subir documento */}
      {user && (
        <div className="Documentation__div--filters">
          {/* Nuevo input para el nombre del documento */}
          <TextField
            label="Nombre del Documento"
            variant="outlined"
            value={documentName}
            onChange={(e) => setDocumentName(e.target.value)}
            style={{ marginBottom: "10px" }}
          />
          <input
            type="file"
            accept=".pdf, .jpg, .jpeg, .png, .gif, .mp4, .webm, .ogg"
            onChange={(e) => setSelectedFile(e.target.files[0])}
            style={{
              border: "2px solid #ccc",
              borderRadius: "5px",
              padding: "8px",
              paddingTop: "10px",
              width: "200px", // Ancho del input
              height: "40px", // Altura del input
              cursor: "pointer", // Cambia el cursor al pasar sobre el input
              boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1)", // Sombra ligera
              outline: "none", // Elimina el contorno al hacer clic
              transition: "border-color 0.3s ease-in-out", // Transición suave al cambiar el borde
              display: "flex", // Usa flexbox
              alignItems: "center", // Centra verticalmente
              justifyContent: "center" // Centra horizontalmente
            }}
          />

          <Button
            variant="contained"
            color="primary"
            sx={{ background: "#333333", ":hover": { background: "#333333" } }}
            onClick={uploadDocument}
            disabled={!selectedFile}
            style={{ marginLeft: "10px" }}
          >
            Subir Documento
          </Button>
        </div>
      )}
      {/* Mostrar la tabla con los documentos */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell>Documento</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {documents.map((doc) => (
              <TableRow key={doc.id}>
                <TableCell>{doc.name2}</TableCell>{" "}
                {/* Mostrar el nombre del documento */}
                <TableCell>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => viewDocument(doc.file, doc.name)}
                    sx={{ color: "#333333", borderColor: "#333333" }}
                  >
                    Ver Documento
                  </Button>
                </TableCell>
                <TableCell>
                  {user && (
                    <IconButton
                      onClick={() => deleteDocument(doc.id)}
                      size="large"
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Visualizador de documento */}
      {selectedDocument && (
        <div
          style={{
            marginTop: "20px",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <h3>{selectedDocument.name}</h3>
          {renderDocument()}
        </div>
      )}
    </div>
  );
};

export default Documentation;
